export const addToolImageContent = async (userMessageForToolImage: any, images: any[], provider: string) => {
    // Google only allows 10 images per message
    if (provider === "Google") images = images.slice(0, 10);

    let toolId = "_";
    const imagePromises = images.map(async (image: any) => {
        toolId = image.fileName;

        if (image.fileContent != null) {
            return image.fileContent;
        }
    });
    const imageContents = await Promise.all(imagePromises);

    for (const fileContent of imageContents) {
        if (fileContent === null || fileContent === undefined) continue;

        userMessageForToolImage.content.push({
            type: 'image_url',
            image_url: {
                url: fileContent
            }
        });
    }

    if (userMessageForToolImage.content.length > 0) {
        userMessageForToolImage.content.push({
            type: 'text',
            text: `The images above are for more context for tool ${toolId} before responding back to me. If the tools message cited image URLs, these are the contents of each URL in order, and you should cite the images in markdown formatting like ![<DESCRIPTION>](<IMAGE_URL>).`
        });
    }
};